/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import { Button, Divider, Stack, useViewport } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useGlobalContext from "../../../hooks/useGlobalContext";
import useModalDialog from "../../../hooks/useModalDialog";
import { customGoal, goal, stage, trackWithDefaultStage } from "@flights/et-universal";
import useEvents from "../../../hooks/useEvents";

import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { isOfGoogleFlightsOrigin, isOfMetaOrigin } from "../../../utils/marketing-url-params";
import { trackMetaLandingsCustomGoalsV2 } from "../../../utils/experiments/track-meta-landings-v2";
import { UIFetchStatus, UIFlightData } from "@flights/types";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import useCreateUrl from "../../../hooks/useCreateUrl";

import { actions as extraProductActions } from "../../../ancillaries/store/extraProducts/actions";
import { preOptedAncillariesURLParams } from "../../../utils/preOptedAncillaries";
import ErrorAlert from "../ErrorAlert";
import FlightCardPrice from "../FlightCard/components/FlightCardPrice";
import Timeline from "../Timeline";
import { getModalTitle } from "./components/flightDetailsUtils";
import FlightsContentSkeleton from "./components/FlightsContentSkeleton";
import useClientMetrics from "../../../hooks/useClientMetrics";
import { ShareFlight } from "../ShareFlight";
import useRetryFlightDetailsApi from "../../../hooks/useRetryFlightDetailsApi";
import useGetUrlParams from "../../../hooks/useGetUrlParams";
import useEventTracking from "../../../hooks/useEventTracking";
import Frame from "../Frame";
import { CURRENT_ORDER_ID_KEY, PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../../constants";
import styles from "./FlightDetailsInner.desktop.module.css";
import { FlightDetailsCampaignBadgeSection } from "./FlightDetailsInner";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData";
import { flightsLocalStore, ryanairUtils } from "@flights/web-api-utils-universal";
import { useDispatch, useSelector } from "react-redux";
import { getPreOptedAncillaries } from "../../../ancillaries/store/extraProducts/selectors";
import { getSearchType } from "../../../store/search/selectors";
import { getSearchCriteria } from "../../../store/searchCriteria/selectors";
import { getFlightDetailsFetchStatus } from "../../../store/flightDetails/selectors";
import { StoreState } from "../../../store";
import AriaLive from "../AriaLive";
import useAvailableBrandedFares from "../../../branded-fares/hooks/useAvailableBrandedFares";
import { useTrackVICheckedBaggage } from "../../../utils/experiments/funnel/flights_funnel_web_vi_checked_baggage";
import useRouteName from "../../../hooks/useRouteName";
import useProfiler from "../../../hooks/useProfiler";

import { WishlistWidgetWrapper } from "../WishlistWidgetWrapper";
import FlightDetailsInfoDesktop from "./components/FlightDetailsInfo/FlightDetailsInfo.desktop";
import flights_web_meta_to_sr_aa from "../../../utils/experiments/funnel/flights_web_meta_to_sr_aa";
import { clientFetch } from "@flights/client-fetch";
import flights_apex_web_show_included_baggage_asap from "../../../utils/experiments/apex/flights_apex_web_show_included_baggage_asap";
import web_flights_fd_genius_saving_badge from "../../../utils/experiments/genius/web_flights_fd_genius_saving_badge";
import { SurveyTrackerLoader } from "../../remote/SurveyTrackerFlightsUniversal";
import flights_split_bounds_us, {
  useSplitBoundsCondition
} from "../../../utils/experiments/funnel/flights_split_bounds_us";
import flights_web_fd_baggage_transparency from "../../../utils/experiments/funnel/flights_web_fd_baggage_transparency";
import flights_apex_web_ryanair_ancillaries_price_label from "../../../utils/experiments/apex/flights_apex_web_ryanair_ancillaries_price_label";

type Props = {
  // In Meta flow `flight` prop might be a response of `/flightFromOfferRelatedFlights`,
  // its response `token` different from the one in request and unusable for checkout.
  // `flightToken` prop is guaranteed to be the full flight details token and must be used for checkout.
  flightToken: string;
  flight?: UIFlightData;

  fetchStatus: UIFetchStatus;
  onClose: VoidFunction;
  onErrorClose: VoidFunction;
  closeAriaLabel?: string;
  hasPrefetchedBrandedFareOffers?: boolean;
  alternativeFaresFlow?: boolean;
};

const FlightDetailsInnerDesktop: FC<Props> = ({
  flightToken,
  flight,
  fetchStatus,
  onClose,
  onErrorClose,
  closeAriaLabel,
  hasPrefetchedBrandedFareOffers,
  alternativeFaresFlow
}) => {
  const history = useHistory();
  const [isModalOpen, setModalOpen] = useState(true);
  const { createUrl } = useCreateUrl();
  const i18n = useI18n();
  const Modal = useModalDialog();
  const { trackClientMetric } = useClientMetrics();
  const { isRetryableFlightDetails } = useRetryFlightDetailsApi();
  const { getUrlParam } = useGetUrlParams();
  const { requestId } = useGlobalContext();
  const trackV2 = useEventTracking("flight_details", requestId);
  const { isLoggedIn, isDirect, isMeta, isDesktop, isMobile, isSolo } = useProfiler();
  const offerCartOrderData = useOfferCartOrderData();
  const preOptedAncillaries = useSelector(getPreOptedAncillaries);
  const searchType = useSelector(getSearchType);
  const flightDetailsFetchStatus = useSelector(getFlightDetailsFetchStatus);
  const flightDetailsError = useSelector((state: StoreState) => state.flightDetails.error);
  const brandedFareOffers = useAvailableBrandedFares();
  const { isLarge, isSmall } = useViewport();
  const { grumble } = useEvents();

  const scrollableRef = useRef<HTMLDivElement>(null);

  const routeName = useRouteName(); // flights_web_tech_pause_sr_loading

  const XM_SURVEY_EXP = "d_xm_flights_details";
  useEffect(() => {
    stage(XM_SURVEY_EXP, 1);
    if (isLoggedIn()) {
      stage(XM_SURVEY_EXP, 2);
    } else {
      stage(XM_SURVEY_EXP, 3);
    }
    if (isDirect()) {
      stage(XM_SURVEY_EXP, 4);
    } else if (isMeta()) {
      stage(XM_SURVEY_EXP, 5);
    }
  }, [XM_SURVEY_EXP, isLoggedIn, isDirect, isMeta]);

  useEffect(() => {
    const { parentOfferToken } = offerCartOrderData.get(flightToken);
    offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: parentOfferToken || flightToken });
  }, [flightToken, offerCartOrderData]);

  useEffect(() => {
    // Track logged-in users who open flight details pages Ddot
    if (isLoggedIn() && flight) {
      stage("ddot_wl_save_flights", 1);
      trackWithDefaultStage("ddot_wl_save_flights", 1);

      /** start - web_flights_fd_genius_saving_badge */
      web_flights_fd_genius_saving_badge.stages.land_on_fd();
      /** end - web_flights_fd_genius_saving_badge */
    }
    // Track when offerKeyToHighlight is nil
    if (flight && !flight.offerKeyToHighlight) {
      customGoal("ddot_wl_save_flights", 1);
    }
  }, [flight, isLoggedIn, isDesktop, isMobile, isSolo]);

  const onFlightSelect = () => {
    if (flight) {
      const orderId = flightsLocalStore.get(CURRENT_ORDER_ID_KEY);

      if (alternativeFaresFlow) {
        void clientFetch("/api/order/track-alternative-fares-event", {
          method: "POST",
          body: JSON.stringify({
            eventType: "ALTERNATIVE_FARE_SELECTED",
            orderId,
            selectedOffer: flight
          }),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        });
      }
      /* start - flights_apex_web_show_included_baggage_asap */
      const isMeta = isOfMetaOrigin();
      const baggageIncluded = Boolean(flight.includedProducts?.segments.some((segment) => segment.length > 0));
      if (baggageIncluded && !isMeta && fetchStatus === "loading") {
        flights_apex_web_show_included_baggage_asap.stages.extras_not_loaded_clicked_next();
      }
      /* end - flights_apex_web_show_included_baggage_asap */

      trackMetaLandingsCustomGoalsV2(3, "desktop"); // track custom goal 3: users progressing beyond FD for meta

      if (flightDetailsFetchStatus !== "success") {
        trackClientMetric("flight_details_quick_checkout_start");
      }
      trackV2("select_flight_details_next");
      goal("flights_flight_details_action_click");

      // We should close modal before navigating to checkout,
      // otherwise BUI modal focus trap would stay active and we'd have no keyboard tab navigation at checkout.
      setModalOpen(false);
      goToCheckout(flightToken);
    }
  };

  //Use this in case flexible Ticket is already selected from meta on flight details. So next screen would be checkout pax.
  const goToCheckout = useCallback(
    (flightToken: string) => {
      let preOpted = preOptedAncillaries;

      if (getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket)) {
        preOpted = { ...preOpted, flexibleTicket: true };
      }
      if (getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason)) {
        preOpted = { ...preOpted, cancelForAnyReason: true };
      }
      const urlParams = preOptedAncillariesURLParams(preOpted);
      if (!preOpted.cancelForAnyReason && !preOpted.flexibleTicket && brandedFareOffers?.length > 0) {
        const baseOfferToken = getUrlParam("baseOfferToken");
        if (baseOfferToken) urlParams.set("baseOfferToken", baseOfferToken);
      }

      if (hasPrefetchedBrandedFareOffers) {
        urlParams.set("hasPrefetchedBrandedFareOffers", "true");
      }

      /** start - flights_ace_web_prevent_double_cart_creation_for_bf **/
      urlParams.set("bfPageLoadTimeStart", Date.now().toString());
      /** end - flights_ace_web_prevent_double_cart_creation_for_bf **/

      const url = createUrl(`/checkout/start/${flightToken}?${urlParams}`);

      // Navigating asynchronously to give flight details modal a chance to close itself (and remove focus trap).
      setTimeout(() => history.push(url));
    },
    [preOptedAncillaries, createUrl, history, getUrlParam, brandedFareOffers, hasPrefetchedBrandedFareOffers]
  );

  useEffect(() => {
    if (fetchStatus === "failed") {
      trackV2("show_error_page");
    }
  }, [fetchStatus, flight, isRetryableFlightDetails, trackV2]);

  const trackMetaTraffic = flights_web_meta_to_sr_aa.useTrackStages();

  const isError = fetchStatus === "failed" && !(flight && isRetryableFlightDetails());

  useTrackVICheckedBaggage();

  if (isError) {
    goal("flights_flight_details_loading_error");

    const caSource = getUrlParam("ca_source");
    if (caSource === "flyAnywhereCityCardFd") {
      grumble("flyAnywhereCityCardFd: goal fired in desktop", {
        flightToken,
        hasFlight: !!flight,
        isRetryable: flight ? isRetryableFlightDetails() : false,
        errorCode: flightDetailsError && "code" in flightDetailsError ? flightDetailsError.code : undefined,
        errorText: flightDetailsError && "text" in flightDetailsError ? flightDetailsError.text : undefined,
        errorMessage: flightDetailsError && "message" in flightDetailsError ? flightDetailsError.message : undefined,
        requestId,
        alternativeFaresFlow
      });
    }

    return (
      <ErrorAlert
        illustration={<NotAvailableIllustration />}
        title={i18n.trans(t("flights_error_unavailable"))}
        body={i18n.trans(t("flights_error_unavailable_body"))}
        buttonLabel={i18n.trans(t("flights_search_action"))}
        onClick={onErrorClose}
      />
    );
  }

  const modalTitle = getModalTitle(i18n, flight?.segments, searchType);
  const isSaveFlightExperimentEnabled = isLoggedIn() && !!trackWithDefaultStage("ddot_wl_save_flights", 3);
  const alignItems = isSaveFlightExperimentEnabled ? "center" : "start";
  const stackPaddingBlockEnd = isSaveFlightExperimentEnabled ? 2 : 0;
  const campaignBadges = fetchStatus === "success" ? flight?.campaignDisplay?.badges ?? [] : [];
  const stackGap = campaignBadges.length > 0 ? 2 : 4;
  const isResponsiveFixes = !isLarge && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);
  const isResponsiveFixesSm = isSmall && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);
  if (flight && ryanairUtils.isRyanairFlightOffer(flight)) {
    flights_apex_web_ryanair_ancillaries_price_label.stages.fd();
    flights_apex_web_ryanair_ancillaries_price_label.stages.fd_ddot();
  }

  return (
    <Modal
      attributes={{ "data-js-fd-modal-root": "true" }}
      overlayAttributes={isResponsiveFixes ? { id: "overlay-sm" } : undefined}
      active={isModalOpen}
      onCloseTrigger={() => {
        if (isModalOpen) {
          // If `isModalOpen=false` it means modal was closed by navigating to checkout.
          // In this case we shouldn't call `onClose()`,
          // otherwise search results url (preceding modal flight details screen) will be pushed to the history.
          trackV2("click_back_button");
          if (routeName.includes("flightdetails")) customGoal("flights_web_tech_pause_sr_loading", 1); // flights_web_tech_pause_sr_loading
          trackMetaTraffic();
          onClose();

          flights_web_fd_baggage_transparency.goals.close_fd();
        }
      }}
      size={"large"}
      title={modalTitle}
      position="center"
      closeAriaLabel={closeAriaLabel}
      className={isResponsiveFixesSm ? styles.modalSm : ""}
    >
      <>
        {flight ? (
          <div data-testid="flightdetails_sheet" ref={scrollableRef}>
            <Stack
              direction="row"
              alignItems={alignItems}
              mixin={{ paddingBlockEnd: stackPaddingBlockEnd }}
              gap={stackGap}
            >
              {campaignBadges.length > 0 && <FlightDetailsCampaignBadgeSection campaignBadges={campaignBadges} />}
              {flight.offerKeyToHighlight && isSaveFlightExperimentEnabled ? (
                <>
                  <div className={campaignBadges.length === 0 ? styles.withMargin : ""}>
                    <WishlistWidgetWrapper flight={flight} />
                  </div>
                  <ShareFlight flight={flight} />
                </>
              ) : (
                <Stack.Item>
                  <Frame mb={4}>
                    <ShareFlight flight={flight} />
                  </Frame>
                </Stack.Item>
              )}
            </Stack>

            <Timeline segments={flight.segments} />

            <Stack gap={4} mixin={{ paddingBlockEnd: 4 }}>
              <Divider />
              <FlightDetailsInfoDesktop flight={flight} fetchStatus={fetchStatus} />
            </Stack>

            <SurveyTrackerLoader />
          </div>
        ) : (
          <FlightsContentSkeleton />
        )}
        <Footer flight={flight} onButtonClick={onFlightSelect} fetchStatus={fetchStatus} />
        {/* App-level <AriaLive /> isn't pronounced when desktop FD modal is open */}
        <AriaLive />
      </>
    </Modal>
  );
};

const Footer: FC<{
  flight?: UIFlightData;
  onButtonClick: () => void;
  fullPadding?: boolean;
  /* start - flights_split_bounds_us */
  fetchStatus: UIFetchStatus;
  /* end - flights_split_bounds_us */
}> = ({ flight, onButtonClick, fullPadding = false, fetchStatus }) => {
  const i18n = useI18n();
  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const { features } = useGlobalContext();
  const enableGfsPosMismatch = features["FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH"] && isOfGoogleFlightsOrigin();
  const dispatch = useDispatch();
  const { getUrlParam } = useGetUrlParams();
  const isFlexTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
  const isCfarTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason);
  const { children } = useSelector(getSearchCriteria);
  const { isSplitBounds } = useSplitBoundsCondition();

  const handleBreakdownOpen = React.useCallback<(status: boolean) => void>((status) => {
    setBreakdownOpen(status);
  }, []);

  useEffect(() => {
    if (isFlexTicket) {
      extraProductActions.addPreOptInProduct("flexibleTicket", true);
      return;
    }
    if (isCfarTicket) {
      extraProductActions.addPreOptInProduct("cancelForAnyReason", true);
      return;
    }

    extraProductActions.removePreOptInProduct("flexibleTicket");
    extraProductActions.removePreOptInProduct("cancelForAnyReason");
  }, [dispatch, isFlexTicket, isCfarTicket]);

  useEffect(() => {
    fetchStatus === "success" && flights_split_bounds_us.goals.fd_fully_loaded();
  }, [fetchStatus]);

  return (
    <Frame
      direction="row"
      alignItems="center"
      p={fullPadding ? 6 : undefined}
      className={`${fullPadding ? styles.footerBorder : styles.footer}}`}
    >
      <div className={styles.priceWrapper} data-testid="flight_details_inner_modal_footer">
        {!!flight && (
          <FlightCardPrice
            flight={flight}
            isRenderedInModal={true}
            alignment="start"
            totalPriceLabel={i18n.trans(t("flights_fd_price_multi"))}
            breakdownOpen={breakdownOpen}
            setBreakdownOpen={handleBreakdownOpen}
            showTotalPriceIncludingAncillaries={true}
            showAvailableSeats={isOfMetaOrigin() && (flight.travellers?.length || 1) <= 2}
            showPricePerPerson={false}
            isFlexTicket={isFlexTicket}
            isCfarTicket={isCfarTicket}
            popoverCloseAriaLabel={i18n.trans(t("flights_a11y_price_breakdown_close_fd"))}
            showPricePerTraveller={children.length > 0}
          />
        )}
      </div>
      <div data-testid="flight_details_inner_modal_select_button">
        <Button
          text={i18n.trans(t("flights_details_select_button"))}
          size="large"
          onClick={onButtonClick}
          loading={!flight || (!enableGfsPosMismatch && flight.posMismatch?.isPOSMismatch)}
          loadingAriaLabel={isSplitBounds ? i18n.trans(t("a11y_flights_fd_cta_spinner_loading")) : ""}
        />
      </div>
    </Frame>
  );
};
export default FlightDetailsInnerDesktop;
